export var getBackEndVars = function () {
    var backEndVars = window.backEndVars;
    return backEndVars;
};
